module.exports = __webpack_public_path__ + "img/Hunter-dwarf-f-70.c26d771f.gif";